import { UserRoles } from '@shared/enums/user-roles.enum';
import { PermissionType } from '../enums/permission-type.enum';
import { PermissionsAction } from '../interfaces/permissions-action.interface';
import { PermissionsConfig } from '../interfaces/permissions-config';

/**
 * @description
 * @author Robert Juszczyk
 * @export
 * @class ProtocolPermissionsConfig
 * @implements {PermissionsConfig}
 */
export class ProtocolPermissionsConfig implements PermissionsConfig {
  static readonly EDIT: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    {
      type: PermissionType.OBJECT_CREATOR_ID
    }
  ];

  static readonly SIGNATURE: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    UserRoles.ROLE_EMPLOYEE_MANAGER,
    {
      type: PermissionType.OBJECT_CREATOR_ID
    }
  ];

  static readonly CLIENT_ADD: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    UserRoles.ROLE_EMPLOYEE_MANAGER,
    {
      type: PermissionType.OBJECT_CREATOR_ID
    }
  ];

  static readonly PREVIEW: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    UserRoles.ROLE_EMPLOYEE_MANAGER,
    // UserRoles.ROLE_EMPLOYEE_WORKER,
    {
      type: PermissionType.OBJECT_CREATOR_ID
    }
  ];

  static readonly ACTIVATE: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    {
      type: PermissionType.OBJECT_CREATOR_ID
    }
  ];

  static readonly ADD: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    UserRoles.ROLE_EMPLOYEE_MANAGER,
    UserRoles.ROLE_EMPLOYEE_WORKER,
    UserRoles.ROLE_EMPLOYEE_EXTERNAL
  ];

  static readonly SEND: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    {
      type: PermissionType.OBJECT_CREATOR_ID
    }
  ];

  static readonly REMOVE: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    {
      type: PermissionType.OBJECT_CREATOR_ID
    }
  ];

  static readonly EXTERNAL_CLIENTS_INFO: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    UserRoles.ROLE_EMPLOYEE_MANAGER,
    UserRoles.ROLE_EMPLOYEE_WORKER
  ];

  static readonly PROTOCOL_STUFFS: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    UserRoles.ROLE_EMPLOYEE_MANAGER,
    UserRoles.ROLE_EMPLOYEE_WORKER,
    UserRoles.ROLE_EMPLOYEE_EXTERNAL
  ];

  static readonly ACCEPTANCE: (PermissionsAction | string)[] = [UserRoles.ROLE_EMPLOYEE_CLIENT];

  static readonly LIST: (PermissionsAction | string)[] = [
    UserRoles.ROLE_EMPLOYEE_CLIENT,
    UserRoles.ROLE_EMPLOYEE_ADMIN,
    UserRoles.ROLE_EMPLOYEE_MANAGER,
    UserRoles.ROLE_EMPLOYEE_WORKER,
    UserRoles.ROLE_EMPLOYEE_EXTERNAL
  ];
}
